import { t } from "@web-solutions/module-localization";

export function getMonthName(monthNumber) {
    const months = {
      '01': t('onboarding.common.calendarShort.January'),
      '02': t('onboarding.common.calendarShort.February'),
      '03': t('onboarding.common.calendarShort.March'),
      '04': t('onboarding.common.calendarShort.April'),
      '05': t('onboarding.common.calendarShort.May'),
      '06': t('onboarding.common.calendarShort.June'),
      '07': t('onboarding.common.calendarShort.July'),
      '08': t('onboarding.common.calendarShort.August'),
      '09': t('onboarding.common.calendarShort.September'),
      '10': t('onboarding.common.calendarShort.October'),
      '11': t('onboarding.common.calendarShort.November'),
      '12': t('onboarding.common.calendarShort.December'),
    };
  
    return months[monthNumber] || t('onboarding.common.calendarShort.invalidMonth');
  }